import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Breadcrumbs,
  BreadcrumbItem,
  Chip,
} from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowAltCircleRight, faArrowLeft, faArrowRightFromBracket, faChevronLeft, faChevronRight, faFileCircleCheck, faSquareXmark } from "@fortawesome/free-solid-svg-icons"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css" //react toastify css
import { jwtDecode } from "jwt-decode"
import { useDispatch, useSelector } from "react-redux"
import { setTokenExpiry } from "../state/authSlice"
import { isMobile } from "react-device-detect"

export default function MainContainer({
  children,
  info = [],
  pageName = "",
  breadcrumbs = [],
  prevPage = {},
}) {
  const [expiryTime, setExpiryTime] = useState(null);

  const { token } = useSelector((state) => state.auth)
  const dispatch = useDispatch();

  useEffect(() => {

    if (token && token != "") {

      const decoded = jwtDecode(token);

      // Extract the expiration time and convert it to a human-readable format
      const expirationTime = new Date(decoded.exp * 1000); // Convert from seconds to milliseconds

      let hours = expirationTime.getHours();
      const minutes = expirationTime.getMinutes();
      const seconds = expirationTime.getSeconds();
      const ampm = hours >= 12 ? 'PM' : 'AM';

      // Convert 24-hour format to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 becomes 12 (for midnight)

      // Format minutes and seconds to always show two digits
      const formattedTime = `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} `;

      setExpiryTime(formattedTime + " " + ampm); // Show in a readable format

      dispatch(setTokenExpiry(expirationTime.getTime() / 1000))
    }
  }, []);

  return (
    //mt-10 ismobil
    <div radius="none" className={`${isMobile ? "mt-10" : ""} " border-0 rounded-none min-h-screen lg:ml-60 lg:pr-5 z-1"`}>
      {/* lg:ml-64 */}
      <ToastContainer className='toast-container'
        toastClassName="dark-toast"
        progressClassName="progress-toast"
      // closeButton={<FontAwesomeIcon  className=" text-xl text-orange-600 absolute right-4 top-1/2 -translate-y-1/2" icon={faSquareXmark} />}
      />
      {/* bg-gradient-to-br from-white via-slate-50 to-slate-50 */}
      <div className="
    sticky top-0 z-40 w-full
   bg-white
    border-b border-slate-200
    shadow-sm
    px-1 py-0
    rounded-md my-1
">

        {/* Top Row */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1.5 w-full">

          {/* Breadcrumbs */}
          <div className="flex items-center min-w-0">
            {breadcrumbs?.length > 0 && (
              <Breadcrumbs
                color="default"
                variant="light"
                className="text-xs"
              >
                {breadcrumbs.map((item, index) => (
                  <BreadcrumbItem
                    key={index}
                    className="text-xs text-orange-400 "
                  >
                    {item}
                  </BreadcrumbItem>
                ))}
              </Breadcrumbs>
            )}
          </div>

          {/* Session Expiry */}
          {expiryTime && (
            <div className="
                flex items-center
                px-2 py-1
                rounded-md
                bg-rose-50
                border border-rose-100
                text-[10px]
                text-rose-600
                font-semibold
                whitespace-nowrap
            ">
              <span className="mr-1 text-rose-400">
                Session expires:
              </span>
              {expiryTime}
            </div>
          )}
        </div>


        {/* Page Title Row */}
        <div className="
        flex flex-col sm:flex-row
        sm:items-center
        sm:justify-between
        gap-2
        my-1
        pb-1
        border-b-1 border-dashed border-slate-500
    ">

          {/* Page Title */}
          <div className="flex items-center min-w-0">

            {/* Icon */}
            <div className="
                flex items-center justify-center
                w-6 h-6
                rounded-md
                bg-gradient-to-br
                from-orange-500
                to-amber-500
                text-white
                shadow-sm
                shrink-0
            ">
              <FontAwesomeIcon
                icon={faArrowRightFromBracket}
                className="text-sm"
              />
            </div>

            {/* Title */}
            <div className="ml-2 min-w-0">
              <h1 className="
                    text-xs
                    font-semibold
                    text-slate-900
                    uppercase
                    tracking-wide
                    truncate
                ">
                {pageName}
              </h1>
            </div>
          </div>


          {/* Back Button */}
          {prevPage?.show && (
            <Chip
              size="sm"
              radius="md"
              variant="flat"
              className="
                    cursor-pointer
                    px-3
                    h-7
                    bg-gradient-to-r
                    from-orange-600
                    to-orange-500
                    hover:from-slate-700
                    hover:to-slate-800
                    text-white
                    font-semibold
                    shadow-sm
                    transition-all
                    duration-200
                "
              startContent={
                <FontAwesomeIcon
                  icon={faArrowLeft}
                  className="text-xs"
                />
              }
              onClick={prevPage?.onClick}
            >
              BACK
            </Chip>
          )}
        </div>


        {/* Page Information */}
        {info?.length > 0 && (
          <div className="
            flex flex-wrap
            items-center
            gap-x-2
            gap-y-1
            py-2
        ">
            {info.map((infoItem, index) => (
              <div
                key={index}
                className="flex items-center"
              >
                <FontAwesomeIcon
                  icon={faChevronRight}
                  className="text-[8px] text-orange-400 mr-1"
                />

                <Chip
                  size="sm"
                  variant="flat"
                  color="success"
                  className="
                            h-6
                            px-2
                           
                            border border-slate-200
                            text-[10px]
                            text-slate-900
                            font-medium
                            shadow-sm
                        "
                >
                  {infoItem.map((item, itemIndex) => (
                    <span key={itemIndex} className="mr-1">
                      {item}
                    </span>
                  ))}
                </Chip>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className=" bg-gradient-to-br from-white  to-gray-50">{children}</div>
      <div></div>
    </div>
  )
}
